import { ModalWindow, IModalWindowProps, Header2, Paragraph1 } from '@cian/ui-kit';

import * as React from 'react';

import { Footer } from './components/Footer';

import * as styles from './styles.css';
// @ts-ignore
import * as image from './fire.png';

type TCoworkingModalAd = Pick<IModalWindowProps, 'open' | 'onClose'>;

export const CoworkingModalAd: React.FC<TCoworkingModalAd> = ({ open, onClose }) => (
  <ModalWindow
    size="M"
    open={open}
    outside={false}
    escape={false}
    onClose={onClose}
    footer={<Footer className={styles['footer']} />}
  >
    <div className={styles['root']}>
      <div className={styles['header']} />
      <div className={styles['content']}>
        <div className={styles['content-item']}>
          <Header2>
            Ого! Теперь у нас можно найти и снять офис в коворкинге
            <img className={styles['icon']} src={image} />
          </Header2>
        </div>
        <div className={styles['content-item']}>
          <Paragraph1>
            Это в среднем на 38% выгоднее, чем обычный офис. В стоимость аренды обычно включены эксплуатационные и
            коммунальные расходы, клининг, мебель, интернет, принтер/сканер и парковка.
          </Paragraph1>
        </div>
      </div>
    </div>
  </ModalWindow>
);

CoworkingModalAd.displayName = 'CoworkingModalAd';
